// "Only listen to me" on the phone page: what the PC knows of the user's voice, per mic.

import { voiceSources, type SpeakerProfileInfo } from "../protocol";

export interface VoiceSetup {
  /** The voice was learned on the PC's mic. */
  pc: boolean;
  /** The voice was learned on this phone's mic. */
  phone: boolean;
  /** The enroll button's wording. */
  action: string;
}

/**
 * From a `speaker.status` profile list: which mics know the user's voice. A phone sees the PC's
 * mic and its own (PROTOCOL.md section 8), so any `device:` mic is this phone.
 */
export function voiceSetup(profiles: SpeakerProfileInfo[]): VoiceSetup {
  const mics = voiceSources(profiles).map((s) => s.source);
  const pc = mics.includes("pc");
  const phone = mics.some((s) => s.startsWith("device:"));
  const action = phone ? "Improve my voice on this phone" : pc ? "Add this phone to my voice" : "Set up my voice";
  return { pc, phone, action };
}
